import '@polymer/paper-spinner/paper-spinner'; // TODO
import { html } from 'lit-element';
// deprecated
/*
 *
 * provide loader counting functionality
 *
 * class A extend  LoaderMixin(parentClass){
 *
 *   someFn(){
 *     ...
 *     promiseLoader(new Promise())
 *     ...
 *
 *     console.log(this.loading); //show loading status
 *   }
 *
 * }
 *
 * */
export default function LoaderMixin(clz) {
  return class extends clz {
    get loading() {
      return this.__$loaderCount > 0;
    }

    __$loaderCount = 0;

    promiseLoader(p) {
      this.__$loaderCount += 1;
      this.requestUpdate();
      return p.finally(() => {
        this.__$loaderCount -= 1;
        this.requestUpdate();
      });
    }

    // default loader
    _renderLoader() {
      if (this.loading) {
        return html`
          <style>
            .spiner-wrapper {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 99;
            }
            paper-spinner {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          </style>
          <div class="spiner-wrapper"><paper-spinner active></paper-spinner></div>
        `;
      }
      return '';
    }
  };
}
